<template>
  <div class="a">
    <div class="analysis-overview">
      <div class="analysis-head">
        <div class="analysis-head__num">01</div>
        <div class="analysis-head__title">测评概览</div>
      </div>
      <div class="p-select">
        <i class="el-icon-date"></i>
          <el-select popper-class="selectFrom" v-model="value" placeholder="" @change="timeChange">
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
              >
            </el-option>
          </el-select>
      </div>
    </div>
     <div class="analysis-list" v-if="evaluation_num!==0">
        <div class="analysis-item">
          <p>被布置的测评数</p>
          <span class="mr-20">{{evaluation_num}}<span class="fz-24">个</span></span>
        </div>
        <div class="analysis-item">
          <p>完成测评数</p>
          <span class="mr-20">{{complete_num}}<span class="fz-24">个</span></span>
        </div>
        <div class="analysis-item">
          <p>平均正答率</p>
          <span class="mr-20">{{avg_accuary}}<span class="fz-24">%</span></span>
        </div>
        <div class="analysis-item">
          <p>测出薄弱知识数</p>
          <span class="mr-20">{{weak_num}}<span class="fz-24">个</span></span>
        </div>
     </div>
     <Empty content="本月暂无测评数据~" type="2" v-else/>
     <evaluation-line :accuaryTrend="accuaryTrend"/>
     <academic-analysis :accountId="account_id" :classId="class_id" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import EvaluationLine from './evaluation-line.vue';
import { getEvaluationAnalyse } from '@/api/pt';
import Empty from './empty.vue';
import AcademicAnalysis from './academic-analysis.vue';

export default {
  name: 'EvaluationAnalysis',
  components: {
    EvaluationLine,
    Empty,
    AcademicAnalysis,
  },
  props: ['account_id', 'created', 'class_id'],
  data() {
    return {
      value: '',
      options: [],
      evaluation_num: '', // 被布置的测评数
      complete_num: '', // 完成测评数
      avg_accuary: '', // 平均正答率
      weak_num: '', // 测出薄弱知识数
      accuaryTrend: [], // 平均正答率趋势
      start_date: null, // 开始时间
    };
  },
  mounted() {
    this.options = this.getMonth();
    this.getEvaluationAnalyse();
  },
  methods: {
    timeChange(val) {
      // console.log(val.substring(0, val.length - 1).replace('年', '-'));
      this.start_date = val.substring(0, val.length - 1).replace('年', '-');
      this.getEvaluationAnalyse();
    },
    getMonth() { // 获取时间列表
      const beforeMoth = dayjs(this.created).add(1, 'month');
      const getmoth = dayjs(new Date()).add(1, 'month');
      this.value = `${getmoth.$y}年${getmoth.$M}月`;
      if (getmoth.$M === 0) {
        this.value = `${getmoth.$y - 1}年12月`;
        this.start_date = `${getmoth.$y - 1}-${12}`;
      } else {
        this.start_date = `${getmoth.$y}-${getmoth.$M}`;
      }
      const list = [];
      if (beforeMoth.$y < getmoth.$y) {
        for (let i = beforeMoth.$M; i <= 12; i += 1) {
          list.unshift({
            value: `${getmoth.$y - 1}年${i}月`,
            label: `${getmoth.$y - 1}年${i}月`,
          });
        }
        for (let i = 1; i <= getmoth.$M; i += 1) {
          list.unshift({
            value: `${getmoth.$y}年${i}月`,
            label: `${getmoth.$y}年${i}月`,
          });
        }
      } else if (beforeMoth.$y === getmoth.$y && beforeMoth.$M === 0) {
        list.unshift({
          value: `${beforeMoth.$y - 1}年${12}月`,
          label: `${beforeMoth.$y - 1}年${12}月`,
        });
        for (let i = 1; i <= getmoth.$M; i += 1) {
          list.unshift({
            value: `${getmoth.$y}年${i}月`,
            label: `${getmoth.$y}年${i}月`,
          });
        }
      } else {
        for (let i = beforeMoth.$M; i <= getmoth.$M; i += 1) {
          list.unshift({
            value: `${getmoth.$y}年${i}月`,
            label: `${getmoth.$y}年${i}月`,
          });
        }
        console.log('list', list);
      }
      return list;
    },
    async getEvaluationAnalyse() {
      const params = {
        account_id: this.account_id,
        start_date: this.start_date,
      };
      const res = await getEvaluationAnalyse(params);
      this.accuaryTrend = res.data.accuary_trend;
      this.avg_accuary = res.data.avg_accuary;
      this.complete_num = res.data.complete_num;
      this.evaluation_num = res.data.evaluation_num;
      this.weak_num = res.data.weak_num;
    },
  },
};
</script>

<style lang="scss" scoped>
.a{
  padding: 41px 60px 0 31px;
  .analysis-overview{
  display: flex;
  justify-content: space-between;
  .analysis-head{
  display: flex;
  align-items: center;
  margin-bottom:11px ;
  &__num{
  font-size: 22px;

  font-weight: bold;
  color: rgba(0, 0, 0, 0.8);
  margin-right: 14px;
  background:url('~@/views/pt/images/class_bg.png');
  background-size:cover;
  width:38px;
  height:29px;
  text-align: center;
  }
  &__title{
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.8);
  }
  }
  .p-select{
  position: relative;
  /deep/ {
    .el-icon-date{
      position: absolute;
      z-index: 999;
      top: 12px;
      left: 14px;
    }
  }
  }
  /deep/ {
  .el-select {
    width: 184px;
    height: 40px;
    .el-input__inner{
      padding-left: 35px;
      color: #1890FF;
    }
  }
  }
   }
  .analysis-list{
    margin: 40px 0 40px 0;
    display: flex;
    justify-content: space-between;
    .analysis-item{
      margin-bottom: 32px;
      width: 230px;
      height: 110px;
      background: #F0F2F8;
      border-radius: 12px;
      padding-left: 21px;
      text-align: center;
      img{
        width: 72px;
        height: 72px;
        margin-right:24px ;
      }
      p{
        font-weight: 500;
        color: #808BAA;
        font-size: 18px;
        margin-top: 20px;
        margin-bottom: 10px;
      }
      .mr-20{
        color:#1989FA;
        font-size: 32px;
      }
      .fz-24{
        font-size: 24px;
        color: #586077;
      }
    }
  }
}
</style>
